
const protocol = window.location.protocol;
const server = {
    dev: {
        tp: '/tprest',
        tour: '/tourrest',
        spa: '/sparest',
        jimu: '/jimurest',
        store: '/storerest',
        apiStore:`${protocol}//j.jimutour.com`
    },
    test: {
        tour: `${protocol}//tour.jimutour.com`,
        tp: `${protocol}//tp.jimutour.com`,
        spa: `${protocol}//spa.jimutour.com/spa`,
        jimu: `${protocol}//j.jimutour.com`,
        store: `${protocol}//store.jimutour.com`,
        apiStore:`${protocol}//j.jimutour.com`
    },
    product: {
        tour: `${protocol}//tour.triplusx.com`,
        tp: `${protocol}//admin.triplusx.com`,
        spa: `${protocol}//spa.triplusx.com/spa`,
        jimu: `${protocol}//jimutour.com`,
        store: `${protocol}//store.triplusx.com`,
        apiStore:`${protocol}//jimutour.com`
    }
};

/**
 * 获取当前环境
 * @returns {number}       1:app  2:本地  3:测试服务器  4:正式服务器
 */
const getEnvironment = () => {
    let href = window.location.origin.replace(/https|http/i, '');
    let tsArr = ['://tp.jimutour.com', '://j.jimutour.com', '://spa.jimutour.com', '://store.jimutour.com', '://tour.jimutour.com'];
    let pdArr = [
        '://jimutour.com',
        '://equity.triplusx.com',
        '://equity1.triplusx.com',
        '://equity2.triplusx.com',
        '://admin.triplusx.com',
        '://www.triplusx.com',
        '://triplusx.com',
        '://store.triplusx.com',
        '://tour.triplusx.com'
    ];

    if (href.indexOf('localhost') > -1) {
        return 2;
    } else if (tsArr.indexOf(href) > -1) {
        return 3;
    } else if (pdArr.indexOf(href) > -1) {
        return 4;
    }
}

const renderDomain = () => {
    let env = getEnvironment();
    let obj;
    switch (env) {
        case 3:
            obj = server.test;
            break;
        case 4:
            obj = server.product;
            break;
        default:
            obj = server.dev;
            break;
    }
    if (env === 4) {
        const origin = window.location.origin
        if (origin !== obj.tp) {
            obj = { ...obj, tp: origin }
        }
    }

    return obj;
}

const domain = renderDomain()
const env = getEnvironment()

export default {
    domain,
    env
};